<template>
  <div>
    <menu-superior class="waves-effect" id="menusuperior-grupo" :titulo="grupo.grupo.nome.toUpperCase()" :colorarrow="corPrimaria" :style="'font-weight: bold;background-color:white;border-style: solid;border-width: 1px;border-color: '+ corPrimaria+';color:'+ corPrimaria"></menu-superior>
    <br>
    <br>
    <div v-for="item in grupo.secoes"  :id="'secao-'+item.detalhes.id" class="container page-section">
      <titulo-secao :fundo="'white'" :titulo="item.detalhes.nome.toLocaleUpperCase()" :style="'border-style: solid;border-width: 1px;border-color: '+ corSecundaria+';color:'+ corSecundaria"></titulo-secao>
      <div class="row" style="margin-top: 10px">
        <card v-for="produto in orderedProd(item.itens, tipoOrdem)" :produto="produto" :key="'itempromocao-'+produto.id" ></card>
      </div>
    </div>
    <meu-pedido-bloco-flutuante-component></meu-pedido-bloco-flutuante-component>
  </div>
</template>

<script>
import TituloSecao from "./template/TituloSecao";
import Item from "../components/Item";
import MenuSuperior from "./template/MenuSuperior";
import SecureLS from "secure-ls";
import Card from "../components/Card";
import MeuPedidoBlocoFlutuanteComponent from "../components/MeuPedidoBlocoFlutuanteComponent";

export default {
  name: "GroupView",
  data(){
    return{
      grupo:null,
      corPrimaria:this.$store.state.empresa.cor_primaria,
      corSecundaria:this.$store.state.empresa.cor_secundaria,
      tipoOrdem: '',
      empresa: this.$store.state.empresa
    }
  },
  components: {MeuPedidoBlocoFlutuanteComponent, Card, MenuSuperior, Item, TituloSecao},
  created() {
    var ls = new SecureLS();
    this.grupo = ls.get('grupo');
    this.tipoOrdem = this.empresa.ordem_lista_produtos 
  },
  mounted()
  {
    // console.log(this.$router.currentRoute.params.id);
    // if(this.$router.currentRoute.params.id != 0){
    //   var elmnt = document.getElementById('secao-' + this.$router.currentRoute.params.id);
    //   console.log(elmnt);
    //   elmnt.scrollIntoView(true);
    //   window.scrollBy(0, -0);
    // }else{
    //   var elmnt = document.getElementById('menusuperior-grupo');
    //   elmnt.scrollIntoView(true);
    //   window.scrollBy(0, -0);
    // }
    this.$nextTick(() => {
      const secaoId = this.$router.currentRoute.params.id;

      if (secaoId !== '0') {
        var elmnt = document.getElementById('secao-' + secaoId);
        if (elmnt) {
          elmnt.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        var menuSuperior = document.getElementById('menusuperior-grupo');
        if (menuSuperior) {
          menuSuperior.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });

    document.getElementById("bodyMain").style = "background-color: white";

    if(this.$store.state.empresa.cor_primaria == undefined)
      this.Voltar();

    if(this.$store.state.empresa.cor_grupo != ""){
      this.corPrimaria = this.$store.state.empresa.cor_grupo;
    }

    if(this.$store.state.empresa.cor_secao != ""){ 
      this.corSecundaria = this.$store.state.empresa.cor_secao;
    }

    if (this.empresa.ordem_lista_produtos == undefined)
    this.tipoOrdem = 'LIVRE'
    else
    this.tipoOrdem = this.empresa.ordem_lista_produtos
  },
  methods:{
    Voltar(){
      this.$router.back();
    },
    orderedProd: function (itens, ordem) {
      
      // return _.orderBy(itens, ['valor'], ['asc']);
      this.empresa
       

      if (ordem == 'MAIOR PRECO')
        return _.orderBy(itens, ['valor_final'], ['desc']);

        if (ordem == 'MENOR PRECO')
        {
          return _.orderBy(itens, ['valor_final'], ['asc']);
        }

        if (ordem == 'ALFABETICA')
        return _.orderBy(itens, ['nome']);

        if (ordem  == 'LIVRE')
        return _.orderBy(itens, ['nome']);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/views/GroupView.vue